<template>
  <v-app :dark="dark">
    <!--全局提示-->
    <l-global right top></l-global>
    <!--全局删除提示-->

    <!--登录过期计时退出对话框-->
    <l-exit-dialog></l-exit-dialog>
    <l-slide-y-enter-transition>
      <keep-alive :include="catchList">
        <router-view></router-view>
      </keep-alive>
    </l-slide-y-enter-transition>
  </v-app>
</template>

<script>
import LExitDialog from "./components/LExitDialog";

export default {
  name: "App",
  components: {
    LExitDialog,
  },
  computed: {
    catchList() {
      let isLogin = this.$store.getters["login/isLogin"];
      // console.log('app cache List', isLogin, this.$L.opts.MAIN_COMPONENT_NAME)
      return isLogin ? [this.$L.opts.MAIN_COMPONENT_NAME] : [];
    },
    dark() {
      return this.$store.getters["L/dark"];
    },
    isLogin() {
      let isLogin = this.$store.getters["login/isLogin"];
      return isLogin;
    },
  },
  methods: {
    async refreshView() {
      let isLogin = this.$store.getters["login/isLogin"];
      let this_ = this;
      if (isLogin) {
        setInterval(this_.refresh, 180000);
      }
    },
    async refresh() {
      let res = await this.$store.dispatch("login/refresh");
      return res;
    },
  },
  created() {
    //this.refreshView()
    console.log(this.$vuetify);
    this.$L.platform.check(window);
  },
  watch: {
    isLogin() {
      this.refreshView();
    },
  },
};
</script>
<style>
html,
body {
  overflow: auto;
}

code {
  box-shadow: 0 0;
  padding: 15px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: normal;
  font-family: Consolas, Roboto, sans-serif;
}

.transition-200 {
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

.transition-250 {
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

.transition-300 {
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

.transition-350 {
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
